import * as O from 'fp-ts/Option';
import { ModaSofa } from '@dora/backpack';
import { Product } from './product';
import { Summary } from './summary';
import * as Pr from './product';

/** A representation of a furniture item in the furniture list and basket */
export type FurnitureItem = {
    aryaId: string;
    products: Array<Product>;
    configuration: O.Option<ModaSofa.Configuration>;
    summary: Summary;
};

/** A bundle of furniture items sold under one SKU */
export type Bundle = {
    canonicalId: string;
    price: number;
    items: Array<FurnitureItem>;
    originalProductIds: Array<string>;
};

export function furnitureProductIds(furniture: FurnitureItem): Array<string> {
    return furniture.products.map(Pr.productId);
}

export function furniturePrice(furniture: FurnitureItem): number {
    return furniture.products.reduce((total, product) => total + product.price, 0);
}

export function bundleExtraProducts(bundle: Bundle): Array<string> {
    const originalProducts = bundle.originalProductIds.slice();
    return bundle.items.flatMap(furnitureProductIds).filter(product => {
        const p = originalProducts.indexOf(product);
        if (p >= 0) {
            originalProducts.splice(p, 1);
            return false;
        } else {
            return true;
        }
    });
}

export function getOriginalBundlePrice(bundle: Bundle) {
    return bundle.items
        .flatMap(item => item.products)
        .reduce((total, product) => total + product.price, 0);
}
export type ItemIdentifier = string;
export function toCartLineItem(items: Array<ItemIdentifier>) {
    return items.reduce((acc, item) => {
        if (acc[item]) {
            acc[item] += 1;
        } else {
            acc[item] = 1;
        }

        return acc;
    }, {} as { [id: string]: number });
}
